import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { catchError, getUserDataFromJwt } from "@_utils/helpers";
import { emailActions } from "@_actions/email_flows.actions";

import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import EmailFlowRow from "@_components/EmailFlowRow/EmailFlowRow";
import EmailTemplate from "@_components/EmailTemplate/EmailTemplate";
import UpgradePlanpopup from "@_components/popups/UpgradePlanPopup/UpgradePlanPopup.js";
import UpgradeImage from "@_assets/images/add_email_flows.png";
import subscriptionCopy from "@_configs/subscription.config.js";
import styles from "./EmailFlows.module.css";

import { Button } from "@mui/material";
import NewEmailFlowPopup from "@_components/popups/NewEmailFlowPopup/NewEmailFlowPopup";
import { emailService } from "@_services/email_flows.service";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { sidebarActions } from "@_actions/sidebar.actions";
import { sidebarConstants } from "@_constants/sidebar.constants";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

function EmailFlows() {
  const dispatch = useDispatch();

  const jwtData = getUserDataFromJwt();

  const emailFlowReducer = useSelector((state) => state.emailFlowReducer);
  const templateReducer = useSelector((state) => state.templateReducer);
  const [emailFlow, setEmailFlow] = useState([]);
  const [newFlow, setNewFlow] = useState({
    name: "",
  });
  const [openNewEmailFlowPopup, setOpenNewEmailFlowPopup] = useState(false);
  const [presetNames, setPresetNames] = useState([]);
  const [selectedPreset, setSelectedPreset] = useState("");
  const [newEmailFlowName, setNewEmailFlowName] = useState("");
  const { snackbarProps, showSnackbarSuccess, showSnackbarError } = useSnackbar();
  const [displayUpgrade, setDisplayUpgrade] = useState(false);
  const [selectedFlowIndex, setSelectedFlowIndex] = useState(-1);
  const subscriptionReducer = useSelector((state) => state.subscriptionReducer);
  const history = useHistory();
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  const { title, subtitle, copy_1, upgradeButton } =
    subscriptionCopy.emailFlow[jwtData.subscription.toLowerCase()];

  const handleInputChange = (e) => {
    if (
      jwtData.subscription.toLowerCase() !== "enterprise" &&
      emailFlowReducer.emailFlows.length >=
        subscriptionReducer.subscriptionConfig.max_email_flows
    ) {
      setDisplayUpgrade(true);
    } else {
      const { name, value } = e.target;
      setNewFlow((newFlow) => ({
        ...newFlow,
        [name]: value,
      }));
    }
  };

  const handleSubmitInput = (e) => {
    e.preventDefault();
    if (newFlow.name) {
      dispatch(emailActions.addEmail({ name: newFlow.name }));
    }
    emailFlow.push(newFlow);
    setNewFlow({ name: "" });
  };

  const handleConfirmNewEmailFlow = () => {
    if (
      jwtData.subscription.toLowerCase() !== "enterprise" &&
      emailFlowReducer.emailFlows.length >=
        subscriptionReducer.subscriptionConfig.max_email_flows
    ) {
      setDisplayUpgrade(true);
    } else {
      dispatch(
        emailActions.addEmail({
          name: newEmailFlowName,
          preset_name: selectedPreset,
        }),
      );
      setEmailFlow([...emailFlow, newEmailFlowName]);
    }
    handleCloseNewEmailFlowPopup();
  };

  const handleOpenNewEmailFlowPopup = async () => {
    try {
      const flowPresetNames = await emailService.getEmailFlowPresets();
      history.push("/templates/email_flows");
      setSelectedFlowIndex(-1);
      setPresetNames(flowPresetNames);
      setOpenNewEmailFlowPopup(true);
    } catch (error) {
      alert("There was a problem loading the presets please try again");
    }
  };

  const handleCloseNewEmailFlowPopup = () => {
    setOpenNewEmailFlowPopup(false);
    setNewEmailFlowName("");
    setSelectedPreset("");
  };

  const handleSelectPreset = (event) => {
    const { options } = event.target;
    let value = "";
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value = options[i].value;
      }
    }
    setSelectedPreset(value);
  };

  const handleNewEmailFlowName = (event) => {
    setNewEmailFlowName(event.target.value);
  };

  useEffect(() => {
    emailFlowReducer.emailFlows &&
      emailFlowReducer.emailFlows.map((email) => {
        return setEmailFlow([...emailFlowReducer.emailFlows]);
      });
  }, [emailFlowReducer.emailFlows]);

  useEffect(() => {
    dispatch(emailActions.getEmail());
    dispatch(sidebarActions.updateStatus(sidebarConstants.EMAIL_FLOWS));
  }, [dispatch]);

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_GET === "success") {
      if (pathParts.length > 2 && pathParts[1] === "email_flows") {
        const flowId = pathParts[2];
        const flowIndex = emailFlowReducer.emailFlows.findIndex(
          (flow) => flow.id === flowId,
        );
        if (flowIndex !== -1) {
          setSelectedFlowIndex(flowIndex);
        } else {
          history.push("/page_not_found");
        }
      }
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_GET"));
    } else if (catchError(emailFlowReducer.status.EMAIL_FLOW_GET)) {
      showSnackbarError(emailFlowReducer.status.EMAIL_FLOW_GET);
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_GET"));
    } else return;
    // eslint-disable-next-line
  }, [dispatch, history, emailFlowReducer.status.EMAIL_FLOW_GET, showSnackbarError]);

  // ERROR AND SUCCESS MESSAGES

  // display email POST success & error
  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_POST === "success") {
      showSnackbarSuccess("Success!");
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_POST"));
    } else if (catchError(emailFlowReducer.status.EMAIL_FLOW_POST)) {
      showSnackbarError(emailFlowReducer.status.EMAIL_FLOW_POST);
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_POST"));
    } else return;
  }, [
    dispatch,
    emailFlowReducer.status.EMAIL_FLOW_POST,
    showSnackbarError,
    showSnackbarSuccess,
  ]);

  // display email PUT success & error
  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_PUT === "success") {
      showSnackbarSuccess("Success!");
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_PUT"));
    } else if (catchError(emailFlowReducer.status.EMAIL_FLOW_PUT)) {
      showSnackbarError(emailFlowReducer.status.EMAIL_FLOW_PUT);
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_PUT"));
    } else return;
  }, [dispatch, emailFlowReducer.status, showSnackbarError, showSnackbarSuccess]);

  // display email DELETE success & error
  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_DELETE === "success") {
      showSnackbarSuccess("deletion successful!");
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_DELETE"));
    } else if (catchError(emailFlowReducer.status.EMAIL_FLOW_DELETE)) {
      showSnackbarError(emailFlowReducer.status.EMAIL_FLOW_DELETE);
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_DELETE"));
    } else return;
  }, [dispatch, emailFlowReducer.status, showSnackbarError, showSnackbarSuccess]);

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_POST === "success") {
      dispatch(emailActions.getEmail());
      setSelectedFlowIndex(emailFlowReducer.emailFlows.length - 1);
    }
    // eslint-disable-next-line
  }, [dispatch, emailFlowReducer.status.EMAIL_FLOW_POST]);

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_PUT === "success") {
      dispatch(emailActions.getEmail());
    }
  }, [dispatch, emailFlowReducer.status.EMAIL_FLOW_PUT]);

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_DELETE === "success") {
      dispatch(emailActions.getEmail());
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_DELETE"));
      setSelectedFlowIndex(-1);
      history.push("/templates/email_flows");
    } else if (catchError(emailFlowReducer.status.EMAIL_FLOW_DELETE)) {
      showSnackbarError(emailFlowReducer.status.EMAIL_FLOW_DELETE);
      dispatch(emailActions.clearStatusMessage("EMAIL_FLOW_DELETE"));
    } else return;
  }, [dispatch, history, emailFlowReducer.status.EMAIL_FLOW_DELETE, showSnackbarError]);

  return (
    <div className={styles.root}>
      <AppSnackbar {...snackbarProps} />
      <div className={styles.flow_list_container}>
        <Scrollbar maxHeight="calc(100vh - 140px)" height="calc(100vh - 140px)">
          <div className={styles.new_flow_button}>
            <Button onClick={handleOpenNewEmailFlowPopup} variant="outlined">
              Create new Mail Flow
            </Button>
          </div>

          {emailFlowReducer.emailFlows &&
            emailFlowReducer.emailFlows.map((emailFlow, index) => {
              return (
                <EmailFlowRow
                  data={emailFlow}
                  key={emailFlow.id}
                  index={index}
                  styles={styles}
                  name={newFlow.name}
                  handleSelectedFlow={() => setSelectedFlowIndex(index)}
                  selectedFlow={index === selectedFlowIndex}
                  handleSubmitInput={handleSubmitInput}
                  handleInputChange={handleInputChange}
                />
              );
            })}
        </Scrollbar>
      </div>
      <NewEmailFlowPopup
        open={openNewEmailFlowPopup}
        presetNames={presetNames}
        name={newEmailFlowName}
        onClose={handleCloseNewEmailFlowPopup}
        onSelect={handleSelectPreset}
        onEmailFlowNameChange={handleNewEmailFlowName}
        onConfirm={handleConfirmNewEmailFlow}
        selectedPreset={selectedPreset}
      />
      <div className={styles.template_container}>
        {templateReducer.selected_template &&
        Object.keys(templateReducer.selected_template).length !== 0 ? (
          <EmailTemplate
            data={templateReducer.selected_template}
            id={templateReducer.flow_templates}
            onClickOutside
          />
        ) : null}

        {(templateReducer.selected_template &&
          Object.keys(templateReducer.selected_template).length === 0 &&
          !templateReducer.add_template) ||
        (!templateReducer.selected_template &&
          !templateReducer.add_template) ? (
          <div className={styles.template_no_data}>
            NO TEMPLATE IS SELECTED!
          </div>
        ) : null}
      </div>
      {displayUpgrade && (
        <UpgradePlanpopup
          title={title}
          subtitle={subtitle}
          upgradeButton={upgradeButton}
          copy_1={copy_1}
          imageUrl={UpgradeImage}
          open={displayUpgrade}
          close={() => setDisplayUpgrade(false)}
        />
      )}
    </div>
  );
}

export default EmailFlows;
